import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filtros_profesiones = _resolveComponent("filtros-profesiones")
  const _component_ListadoAgrupacionesProfesiones = _resolveComponent("ListadoAgrupacionesProfesiones")
  const _component_busqueda_con_filtros = _resolveComponent("busqueda-con-filtros")

  return (_openBlock(), _createBlock(_component_busqueda_con_filtros, {
    loading: _ctx.loading,
    page: _ctx.page,
    filtro: _ctx.filtro,
    titulo: _ctx.titulo,
    "show-busqueda": _ctx.showListado,
    onLimpiar: _ctx.limpiar,
    onBuscar: _ctx.buscar
  }, {
    filtros: _withCtx(({ filtro }) => [
      _createVNode(_component_filtros_profesiones, {
        ref: "filtroComponent",
        filtro: filtro
      }, null, 8, ["filtro"])
    ]),
    listados: _withCtx(({ loading, pagination, data }) => [
      _createVNode(_component_ListadoAgrupacionesProfesiones, {
        loading: loading || _ctx.loadingListado,
        profesiones: data,
        pagination: pagination,
        onPagination: _ctx.buscar
      }, null, 8, ["loading", "profesiones", "pagination", "onPagination"])
    ]),
    _: 1
  }, 8, ["loading", "page", "filtro", "titulo", "show-busqueda", "onLimpiar", "onBuscar"]))
}